/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import getChoiceIconStyle from "assets/getChoiceIconStyle";

const O_minus = ({ isActive = false }) => {
  const fill = getChoiceIconStyle(isActive);
  return (
    <svg
      width="80"
      height="80"
      viewBox="10 10 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="80" height="80" fill="none" />
      <path
        d="M46.364 61.752C44.4973 61.752 42.864 61.3413 41.464 60.52C40.0827 59.68 39.0093 58.504 38.244 56.992C37.4973 55.4613 37.124 53.6693 37.124 51.616C37.124 50.0667 37.3387 48.676 37.768 47.444C38.1973 46.1933 38.8133 45.1293 39.616 44.252C40.4187 43.356 41.3893 42.6747 42.528 42.208C43.6667 41.7413 44.9453 41.508 46.364 41.508C48.2493 41.508 49.8827 41.9187 51.264 42.74C52.6453 43.5613 53.7093 44.728 54.456 46.24C55.2213 47.752 55.604 49.5347 55.604 51.588C55.604 53.1373 55.3893 54.5373 54.96 55.788C54.5307 57.0387 53.9053 58.112 53.084 59.008C52.2813 59.904 51.3107 60.5853 50.172 61.052C49.0333 61.5187 47.764 61.752 46.364 61.752ZM46.364 59.232C47.6707 59.232 48.7813 58.9333 49.696 58.336C50.6293 57.7387 51.3387 56.8707 51.824 55.732C52.328 54.5933 52.58 53.2213 52.58 51.616C52.58 49.208 52.0387 47.3413 50.956 46.016C49.8733 44.6907 48.3427 44.028 46.364 44.028C45.0573 44.028 43.9373 44.3267 43.004 44.924C42.0893 45.5027 41.38 46.3613 40.876 47.5C40.3907 48.6387 40.148 50.0107 40.148 51.616C40.148 54.0053 40.6893 55.872 41.772 57.216C42.8733 58.56 44.404 59.232 46.364 59.232ZM60.1509 55.172C59.8149 55.172 59.5349 55.06 59.3109 54.836C59.0869 54.612 58.9749 54.3413 58.9749 54.024C58.9749 53.688 59.0869 53.4173 59.3109 53.212C59.5349 52.988 59.8149 52.876 60.1509 52.876H66.3109C66.6283 52.876 66.8989 52.988 67.1229 53.212C67.3469 53.4173 67.4589 53.688 67.4589 54.024C67.4589 54.3413 67.3469 54.612 67.1229 54.836C66.8989 55.06 66.6283 55.172 66.3109 55.172H60.1509Z"
        fill={fill}
      />
    </svg>
  );
};

export default O_minus;
